// extracted by mini-css-extract-plugin
export var addToCartButton = "_os-b";
export var arrowButtonContainer = "_os-9";
export var arrowButtonIcon = "_os-a";
export var carouselArrowButton = "_os-6";
export var carouselElementContainer = "_os-1";
export var galleryThumbnail = "_os-d";
export var galleryThumbnailImage = "_os-e";
export var left = "_os-7";
export var productDisplayCarouselContainer = "_os-0";
export var productTileContainer = "_os-2";
export var productTileImage = "_os-4";
export var productTileImageContainer = "_os-3";
export var productTileTitle = "_os-5";
export var right = "_os-8";
export var sliderOverflow = "_os-c";